import { render, staticRenderFns } from "./group_message_sender.vue?vue&type=template&id=74504930&"
import script from "./group_message_sender.vue?vue&type=script&lang=js&"
export * from "./group_message_sender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports